module.exports = __webpack_public_path__ + "static/media/message.d6cbf113.svg";